export const ErrorHandler =  (error) => {
  if (error?.response) {
      console.log("Error Handler Call", error?.response?.data?.message);
     
      if (error?.response?.status === 401) {
        
        localStorage.clear();
      
        window.location.href ="/login";
        

      }
     else if (error?.response?.status === 400) {
        
       
      return error?.response?.data?.message;

      }
      return error.response.data;
    } else if (error.request) {
      return error.message;
    } else {
      return "Something went wrongs";
    }
  };